import { FILTER, KretsAction, SelectedKrets } from './krets-actions';

export default function kretsReducer(kretsFilter: SelectedKrets[] = [], action: KretsAction): SelectedKrets[] {
  if (action.type === FILTER) {
    return [...(action.selected || [])];
  }
  return kretsFilter;
}
